module.exports = __webpack_public_path__ + "assets/img/hot_water_loop_pump.da377a6f.svg";